import { preventDefaultMouseEvent } from "@app/shared/utility/preventDefaultMouseEvent";
import { JSX } from "react";

/**
 * Renders a skeleton Panel
 * @param props
 */
function Panel(props: { className?: string, dark?: boolean, title?: string, transparent?: boolean }): JSX.Element {
  const classes = `panel-group${props.dark ? " panel-dark" : " panel-default"}${props.transparent ? " panel-transparent" : ""} ${props.className || ""}`;
  return (
    <div className={classes}>
      <div className="panel panel-default">
        <div className="panel-heading">
          <h4 className="panel-title"><a href="#" onClick={preventDefaultMouseEvent} className="collapsed"><span className="bone">{props.title}</span></a></h4>
        </div>
      </div>
    </div>
  );
}

export { Panel };
